import { type MfaPromptState } from '../MfaPromptState';

const INITIAL_STATE: MfaPromptState = {
  isOpen: false,
  onSuccessMessage: undefined,
};

export default INITIAL_STATE;
